import React from 'react'
import { Link } from 'react-router-dom'

const Button = ({ link, title, handleClick }) => {
  return (
    <Link to={link}>
      <button onClick={handleClick} className='started lg:w-[190px] w-full px-2 py-3 rounded-xl hover:bg-red-400 hover:text-black text-white lg:text-[18px] text-[14px] flex items-center justify-center'>{title}</button>
    </Link>
  )
}

export default Button